import Sidebar from './Sidebar.vue';

export default Sidebar;
